export const renderAcronym = (row) => (
  <span className={`acronym ${row.style}`}>{row.name}</span>
);

export const renderDefinition = (row) => (
  <span
    className={`definition ${row.style}`}
    dangerouslySetInnerHTML={{ __html: row.definition }}
  ></span>
);

export const renderStatus = (row) => (
  <span className={`status ${row.style}`}>{row.status}</span>
);

export const renderLocation = (row) => (
  <span
    className="location"
    dangerouslySetInnerHTML={{ __html: row.location }}
  ></span>
);

export const render1stOccurrence = (row) => (
  <span
    className="paragraph"
    dangerouslySetInnerHTML={{ __html: row.paragraph }}
  ></span>
);

export const renderCount = (row) => (
  <span className="occurrences">{row.occurrences}</span>
);

export const sortData = (data, sortColumn, sortOrder, type) => {
  let compareFunc = (a, b) =>
    sortOrder === "ASC"
      ? ("" + a[sortColumn]).localeCompare(b[sortColumn])
      : -("" + a[sortColumn]).localeCompare(b[sortColumn]);
  if (type === "number") {
    compareFunc = (a, b) =>
      sortOrder === "ASC"
        ? b[sortColumn] - a[sortColumn]
        : a[sortColumn] - b[sortColumn];
  }
  return data.sort(compareFunc);
};
